import React from 'react'
import { MuiTextfield } from 'material-ui-elements'
import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole } = commonConfigValues

const { helpers: { keepInLength, calculateFlag } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const actionStatus = [
  { id: 1, label: 'Cancelled - SW Decision' },
  { id: 2, label: 'Completed - Action Ongoing' },
  { id: 3, label: 'Completed - No Further Action' },
  { id: 4, label: 'In Progress - Behind Schedule' },
  { id: 5, label: 'In Progress - No Identified Schedule' },
  { id: 6, label: 'In Progress - On Schedule' },
  { id: 7, label: 'Pending - Behind Schedule' },
  { id: 8, label: 'Pending - No Identified Schedule' },
  { id: 9, label: 'Pending - On Schedule' }
]

export const valueTable = {
  actionStatus
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'carePlan.date',
      'carePlan.reviewDecision',
      'carePlan.action',
      'carePlan.originalActionDueDate',
      'carePlan.revisedActionDueDate',
      'carePlan.status',
      'carePlan.validFrom',
      'carePlan.actionFlag'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Namewww '
  },
  {
    name: 'carePlan.date',
    title: 'Care Plan Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Care Plan Da '
  },
  {
    name: 'carePlan.number',
    title: 'Care Plan Number',
    formField: true,
    maxChars: 2,
    minSpace: 'Care Plan Nu '
  },
  {
    name: 'carePlan.reviewDecision',
    title: 'Child in Care Review Decision(s)',
    formField: true,
    maxChars: 500,
    minSpace: 'Child in Care Review '
  },
  {
    name: 'carePlan.action',
    title: 'Associated Action(s)',
    formField: true,
    maxChars: 500,
    minSpace: 'Associated Action(s) '
  },
  {
    name: 'carePlan.responsiblePerson',
    title: 'Person Responsible for Implementing this Decision Name(s)',
    formField: true,
    maxChars: 50,
    minSpace: 'Implementing this Decision Name(s) '
  },
  {
    name: 'carePlan.theirRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    options: 'theirRole',
    filterField: true,
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`carePlan.theirRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`carePlan.theirRole`], 10)])
            .label
        : row[`carePlan.theirRole`],
    minSpace: 'Their Role '
  },
  {
    name: 'carePlan.originalActionDueDate',
    title: 'Original Action Due Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Original Action '
  },
  {
    name: 'carePlan.revisedActionDueDate',
    title: 'Revised Action Due Date (I/A)',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Revised Action '
  },
  {
    name: 'carePlan.status',
    title: 'Action Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(valueTable.actionStatus, [
        'id',
        parseInt(row[`carePlan.status`], 10)
      ])
        ? _.find(valueTable.actionStatus, [
            'id',
            parseInt(row[`carePlan.status`], 10)
          ]).label
        : row[`carePlan.status`],
    options: 'actionStatus',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'carePlan.validFrom',
    title: 'Action Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'carePlan.actionFlag',
    title: 'Care Plan Action Flags',
    formField: true,
    // type: 'boolean',
    filterField: true,
    minSpace: 'Action Flags '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'carePlan',
      historyName: 'carePlanHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'cpl',
      activeName: 'carePlan',
      historyName: 'carePlanHistory',
      label: 'Care Planning',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'carePlan.date',
            label: 'Care Plan Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'carePlan.number',
            label: 'Care Plan Number',
            normalize: v => {
              const val = keepInLength(v, 2)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'carePlan.reviewDecision',
          label: 'Child in Care Review Decision(s)',
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },

        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'carePlan.action',
          label: 'Associated Action(s)',
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'carePlan.responsiblePerson',
            label: 'Person Responsible for Implementing this Decision Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'carePlan.theirRole',
            label: 'Their Role',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'carePlan.originalActionDueDate',
            label: 'Original Action Due Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'carePlan.actionFlag',
                calculateFlag(
                  (formValues &&
                    formValues.carePlan &&
                    formValues.carePlan.revisedActionDueDate) ||
                    v
                )
              )
            },
            validate: v => (v ? undefined : 'Field is required')
          },

          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'carePlan.revisedActionDueDate',
            label: 'Revised Action Due Date (I/A)',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(formName, 'carePlan.actionFlag', calculateFlag(v))
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'carePlan.status',
            label: 'Action Status',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.actionStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'carePlan.validFrom',
            label: 'Action Status Valid at Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculateFlag(
                  (formValues &&
                    formValues.carePlan &&
                    formValues.carePlan.originalActionDueDate) ||
                    (formValues &&
                      formValues.carePlan &&
                      formValues.carePlan.originalActionDueDate)
                )}
                label={'Care Plan Action Flags'}
              />
            ),
            name: 'carePlan.actionFlag',
            label: 'Care Plan Action Flags'
          }
        ]
      ]
    }
  ]

  return forms
}

export const activeSection = ['carePlan']

export const errors = [1, 2]

export const defaultNew = {
  carePlan: {
    historyId: 'new'
  },
  carePlanHistory: []
}

// "carePlans": [
//   {
// "carePlan": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "number": "22",
//   "reviewDecision": "aaa",
//   "action": "aaa",
//   "responsiblePerson": "aaa",
//   "theirRole": "aaa",
//   "originalActionDueDate": "2001-01-01T23:28:56.782Z",
//   "revisedActionDueDate": "2001-01-01T23:28:56.782Z",
//   "status" : 2,
//   "validFrom": "2001-01-01T23:28:56.782Z",
//   "actionFlag": 1
// },
// "carePlanHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/carePlans.js